import { ACCESS } from '@src/configs/permission'
import { useQueryRoleCurrent } from '@src/queries/hooks'
import { useEffect, useState } from 'react'

export const usePermissionCurrent = (token: string) => {
  const [permissions, setPermissions] = useState<ACCESS[]>([])
  const { data, isLoading, isFetching } = useQueryRoleCurrent(token)
  useEffect(() => {
    const roles = data?.data || []
    const newPermissions: ACCESS[] = []
    if (Array.isArray(roles) && roles?.length > 0) {
      roles.forEach((role) => {
        const permissions = (role?.permissions ? role.permissions.trim().split(',') : []) as ACCESS[]
        if (Array.isArray(permissions) && permissions?.length > 0) {
          permissions.forEach((permission) => {
            if (permission) newPermissions.push(permission)
          })
        }
      })
    }
    const pmsUnique = newPermissions.reduce((unique: ACCESS[], p) => {
      if (unique.findIndex((u) => u === p) < 0) {
        unique.push(p)
      }
      return unique
    }, [])
    setPermissions([...pmsUnique])
  }, [data])

  return {
    permissions: [...permissions, ACCESS.GENERAL],
    isLoading,
    isFetching,
  }
}
